"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SportTypes = void 0;
exports.SportTypes = {
    SOCCER: 1,
    BASKETBALL: 2,
    BASEBALL: 3,
    ICE_HOCKEY: 4,
    TENNIS: 5,
    HANDBALL: 6,
    FLOORBALL: 7,
    TROTTING: 8,
    GOLF: 9,
    BOXING: 10,
    MOTOR_SPORT: 11,
    RUGBY: 12,
    AUSSIE_RULES: 13,
    WINTER_SPORTS: 14,
    BANDY: 15,
    AMERICAN_FOOTBALL: 16,
    CYCLING: 17,
    SPECIALS: 18,
    SNOOKER: 19,
    TABLE_TENNIS: 20,
    CRICKET: 21,
    DARTS: 22,
    VOLLEYBALL: 23,
    FIELD_HOCKEY: 24,
    POOL: 25,
    WATERPOLO: 26,
    GAELIC_SPORTS: 27,
    CURLING: 28,
    FUTSAL: 29,
    OLYMPICS: 30,
    BADMINTON: 31,
    BOWLS: 32,
    CHESS: 33,
    BEACH_VOLLEY: 34,
    NETBALL: 35,
    ATHLETICS: 36,
    SQUASH: 37,
    RINK_HOCKEY: 38,
    LACROSSE: 39,
    FORMULA1: 40,
    DTM: 42,
    ALPINE_SKIING: 43,
    BIATHLON: 44,
    BOBSLEIGH: 45,
    CROSS_COUNTRY: 46,
    NORDIC_COMBINED: 47,
    SKI_JUMPING: 48,
    SNOWBOARD: 49,
    SPEED_SKATING: 50,
    LUGE: 51,
    SWIMMING: 52,
    SOFTBALL: 54,
    HORSE_RACING: 55,
    SCHWINGEN: 56,
    INLINE_HOCKEY: 57,
    GREYHOUND: 58,
    BEACH_SOCCER: 60,
    PESAPALLO: 61,
    STREET_HOCKEY: 62,
    ROWING: 64,
    MOTOGP: 67,
    MOTO2: 68,
    MOTO3: 69,
    _125CC: 0,
    NASCAR_CUP_SERIES: 70,
    PADEL_TENNIS: 71,
    CANOEING: 72,
    HORSEBALL: 73,
    ARCHERY: 75,
    EQUESTRIAN: 76,
    FENCING: 77,
    GYMNASTICS: 78,
    JUDO: 79,
    MODERN_PENTATHLON: 80,
    SAILING: 81,
    SHOOTING: 82,
    TAKEWONDO: 83,
    TRIATHLON: 84,
    WEIGHTLIFTING: 85,
    WRESTLING: 86,
    OLYMPCS_YOUTH: 87,
    MOUNTAIN_BIKE: 88,
    SURFING: 90,
    RHYTHMIC_GYMNASTICS: 93,
    TRAMPOLINE_GYMNASTICS: 94,
    ARTISTIC_SWIMMING: 95,
    DIVING: 96,
    TRACK_CYCLING: 97,
    BEACH_TENNIS: 98,
    SUMO: 99,
    SUPERBIKE: 100,
    RALLY: 101,
    FIGURE_SKATING: 102,
    FREESTYLE_SKIING: 103,
    SKELETON: 104,
    SHORT_TRACK: 105,
    SOCCER_MYTHICAL: 106,
    E_SPORT: 107,
    WORLD_LOTTERY: 108,
    COUNTER_STRIKE: 109,
    LEAGUE_OF_LEGENDS: 110,
    DOTA2: 111,
    STARCRAFT: 112,
    HEARTHSTONE: 113,
    HEROES_OF_THE_STORM: 114,
    WORLD_OF_TANKS: 115,
    POLO: 116,
    MMA: 117,
    CALL_OF_DUTY: 118,
    SMITE: 119,
    VAINGLORY: 120,
    OVERWATCH: 121,
    WARCRAFT_III: 122,
    CROSSFIRE: 123,
    HALO: 124,
    RAINBOW_SIX: 125,
    SEPAK_TAKRAW: 126,
    STREET_FIGHTER_V: 127,
    ROCKET_LEAGUE: 128,
    INDY_RACING: 129,
    SPEEDWAY: 131,
    ESPORT_GEARS_OF_WAR: 132,
    ESPORT_CLASH_ROYALE: 133,
    ESPORT_KING_OF_GLORY: 134,
    GAELIC_FOOTBALL: 135,
    GAELIC_HURLING: 136,
    ESOCCER: 137,
    KABADDI: 138,
    ESPORT_QUAKE: 139,
    ESPORT_PLAYERUNKNOWNS_BATTLEGROUNDS: 140,
    CYCLING_CYCLE_BALL: 141,
    FORMULA_E: 142,
    "7BALLRUN": 143,
    MOTOCROSS: 144,
    DRAG_RACING: 147,
    ESPORT_WORLD_OF_WARCRAFT: 152,
    EBASKETBALL: 153,
    ESPORT_DRAGON_BALL_FIGHTERZ: 154,
    BASKETBALL_3X3: 155,
    ESPORT_TEKKEN: 156,
    BEACH_HANDBALL: 157,
    ESPORT_ARENA_OF_VALOR: 158,
    ESPORT_TF2: 159,
    ESPORT_SSBM: 160,
    ESPORT_PALADINS: 161,
    ESPORT_ARTIFACT: 162,
    INDOOR_SOCCER: 163,
    INDY_LIGHTS: 165,
    ESPORT_PRO_EVOLUTION_SOCCER: 166,
    ESPORT_BRAWL_STARS: 168,
    PETANQUE: 169,
    ESPORT_FORTNITE: 170,
    ESPORT_MTG: 171,
    FISHING: 172,
    ESPORT_DOTA_UNDERLORDS: 173,
    ESPORT_TEAMFIGHT_TACTICS: 174,
    ESPORT_AUTO_CHESS: 175,
    ESPORT_FIGHTING_GAMES: 176,
    ESPORT_MOTORSPORT: 178,
    CYCLING_BMX_FREESTYLE: 179,
    CYCLING_BMX_RACING: 180,
    KARATE: 181,
    MARATHON_SWIMING: 182,
    SKATEBOARDING: 183,
    SPORT_CLIMBING: 184,
    NASCAR_CAMPING_WORLD_TRUCK: 185,
    NASCAR_XFINITY_SERIES: 186,
    NHRA: 187,
    TOURING_CAR_RACING: 188,
    FORMULA_2: 189,
    MOTORCYCLE_RACING: 190,
    STOCK_CAR_RACING: 191,
    AIR_RACING: 192,
    ENDURANCE_RACING: 193,
    ESPORT_VALORANT: 194,
    EICE_HOCKEY: 195,
    EVOLLEYBALL: 198,
    ESPORT_WILD_RIFT: 199,
};
//# sourceMappingURL=sportTypes.js.map